import script from "./AccountDetailInfoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountDetailInfoForm.vue?vue&type=script&setup=true&lang=ts"

import "./AccountDetailInfoForm.vue?vue&type=style&index=0&id=27921798&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27921798"]])

export default __exports__